import(/* webpackMode: "eager" */ "/Users/shenbagakrithika/Documents/Boo Stuff/instrutech/src/app/not-found.tsx");
